import { statusLabel, statusTone } from '../shared/normalizers';

export function Badge({ value }: { value: unknown }) {
  return <span className={`badge badge--${statusTone(value)}`}>{statusLabel(value)}</span>;
}
